import { useMemo } from 'react';
import DefaultLayout from '../../layouts/DefaultLayout';
import apiClient from '../../services/api/apiClient';
import { Helmet } from 'react-helmet-async';
import { SoldeClientDTO } from '../../utils/types/objects/SoldeClientDTO';
import SoldeClientGrid from '../../components/grid/SoldeClientGrid';
import { useQuery } from '@tanstack/react-query';
import QueryErrorAlerts, { QueryErrorEntry } from '../../components/others/QueryErrorAlerts';
import { Spinner } from 'react-bootstrap';

const SoldeClientPage = () => {
    const {
        data: soldesClients = [],
        isLoading: isLoadingSoldesClients,
        refetch: refetchSoldesClients,
        isError: isSoldesClientsError,
        error: soldesClientsError,
    } = useQuery<SoldeClientDTO[]>({
        queryKey: ['soldesClients'],
        queryFn: async () => {
            const res = await apiClient.get('/api/clients/get-soldes-clients');
            return res.data ?? [];
        },
        meta: { title: 'Chargement des clients' },
        staleTime: 0
    });

    // ---

    const queryErrors = useMemo<QueryErrorEntry[]>(() => [{ isError: isSoldesClientsError, error: soldesClientsError, title: 'Erreur lors du chargement des soldes clients', refetch: refetchSoldesClients }], [isSoldesClientsError, soldesClientsError, refetchSoldesClients]);

    // ---

    return (
        <>
            <Helmet>
                <title>Soldes Clients :: Portail PETROSIL</title>
            </Helmet>

            <div className="page-header d-print-none">
                <div className="container-xl">
                    <div className="row g-2 align-items-center">
                        <div className="col">
                            <div className="page-pretitle">Rapport</div>
                            <h2 className="page-title">Soldes Clients</h2>
                        </div>
                        <div className="col-auto ms-auto d-print-none">
                            <div className="btn-list">
                                <span className="d-none d-sm-inline">
                                    <button
                                        type="button"
                                        className="btn btn-1"
                                        disabled={isLoadingSoldesClients}
                                        onClick={() => {
                                            refetchSoldesClients();
                                        }}
                                    >
                                        {isLoadingSoldesClients ? (
                                            <>
                                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                &nbsp; Actualiser
                                            </>
                                        ) : (
                                            'Actualiser'
                                        )}
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-body">
                <div className="container-xl">
                    <QueryErrorAlerts queries={queryErrors} />

                    <div className="mt-2">
                        <SoldeClientGrid soldesClients={soldesClients} />
                    </div>
                </div>
            </div>
        </>
    );
};

SoldeClientPage.Layout = DefaultLayout;

export default SoldeClientPage;
